import * as React from "react"
import Autocomplete, {autocompleteClasses} from "@mui/material/Autocomplete"
import useMediaQuery from "@mui/material/useMediaQuery"
import Popper from "@mui/material/Popper"
import {styled, useTheme} from "@mui/material/styles"
import {VariableSizeList} from "react-window"
import Typography from "@mui/material/Typography"

const LISTBOX_PADDING = 3// px

function renderRow(props) {
    const {data, index, style} = props
    const dataSet = data[index]
    const inlineStyle = {
        ...style,
        top: style.top + LISTBOX_PADDING,
        whiteSpace: 'initial',
        fontSize: '12px',
        paddingBottom: '7px',
        overflow: 'hidden'
    }
    const {children, ...rest} = dataSet.props;

    return (
        <Typography component="div" {...rest} noWrap style={inlineStyle}>
            <span style={{
                maxHeight: '100%',
                maxWidth: '100%',
                overflow:'hidden',
                textOverflow:'ellipsis'
            }}>
                   {children}
            </span>
        </Typography>
    )
}

const OuterElementContext = React.createContext({})

const OuterElementType = React.forwardRef((props, ref) => {
    const outerProps = React.useContext(OuterElementContext)
    return <div ref={ref} {...props} {...outerProps} />
})

function useResetCache(data) {
    const ref = React.useRef(null)
    React.useEffect(() => {
        if (ref.current != null) {
            ref.current.resetAfterIndex(0, true)
        }
    }, [data])
    return ref
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(
    props,
    ref
) {
    const {children, ...other} = props
    const itemData = []
    children.forEach(item => {
        itemData.push(item)
        itemData.push(...(item.children || []))
    })

    const theme = useTheme()
    const smUp = useMediaQuery(theme.breakpoints.up("sm"), {
        noSsr: true
    })
    const itemCount = itemData.length
    const itemSize = smUp ? 72 : 72

    const getChildSize = child => {
        if (child.hasOwnProperty("group")) {
            return 48
        }

        return itemSize
    }

    const getHeight = () => {
        if (itemCount > 8) {
            return 8 * itemSize
        }
        return itemData.map(getChildSize).reduce((a, b) => a + b, 0)
    }

    const gridRef = useResetCache(itemCount)


    return (
        <div ref={ref}>
            <OuterElementContext.Provider value={other}>
                <VariableSizeList
                    itemData={itemData}
                    height={getHeight() + 2 * LISTBOX_PADDING}
                    width="100%"
                    ref={gridRef}
                    outerElementType={OuterElementType}
                    innerElementType="ul"
                    itemSize={index => getChildSize(itemData[index])}
                    overscanCount={5}
                    itemCount={itemCount}
                >
                    {renderRow}
                </VariableSizeList>
            </OuterElementContext.Provider>
        </div>
    )
})


const StyledPopper = styled(Popper)({
    [`& .${autocompleteClasses.listbox}`]: {
        boxSizing: "border-box",
        "& ul": {
            padding: 0,
            margin: 0
        }
    }
})


function SelectMultiSearchVirtualize({data, ...rest}) {
    return (
        <Autocomplete
            {...rest}
            disableListWrap
            PopperComponent={StyledPopper}
            ListboxComponent={ListboxComponent}
        />
    )
}

export default SelectMultiSearchVirtualize;